import { render, staticRenderFns } from "./groupTable.vue?vue&type=template&id=0850e698&scoped=true&"
import script from "./groupTable.vue?vue&type=script&lang=js&"
export * from "./groupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0850e698",
  null
  
)

export default component.exports